import { Component, OnInit ,Output,EventEmitter, Input } from '@angular/core';
import { Config } from '../../config/config';
import { RestDataService } from '../../service/rest-data.service';
import { FormControl } from '@angular/forms';
import { StaticViewDataService } from '../../service/static-view-data-service.service';
import { SharedDataService } from '../../service/shared-data.service';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { DateUtil } from '../../utils/DateUtil';


@Component({
  selector: '.app-story-type-listing',
  templateUrl: './story-type-listing.component.html',
  styleUrls: ['./story-type-listing.component.scss']
})
export class StoryTypeListingComponent implements OnInit {
  sortByValueOf: string;
  fields: string;
  fieldsForTopic: string;
  hyperlinkUrlSend: any;

  @Input()
  set storySearchText(getTopicName_string: string) {
    this.topicName = (getTopicName_string && getTopicName_string.trim()) ? getTopicName_string : null;
  }
  
  
  @Output() sendpageUrlToParentfn = new EventEmitter<any>();
  searchQuery: FormControl = new FormControl();
  pageSize = 50;
  pages = 34;
  api: string;
  topicName: string;
  hyperlinkUrl: string = '';
  listArray = [];
  listIdArray: any[] = [];
  listArrayTopic = [];
  listIdArrayTopic: any[] = [];
  getDataUrl = this.config.get('product').baseUrl + StaticViewDataService.Story_listing_View.urls.listing;
  getTopicData = this.config.get('product').baseUrl + StaticViewDataService.Page_listing_View.urls.listing;
  public pageNum = 0;
  noresults = false;
  constructor(private config: Config, private restService: RestDataService, private sharedService: SharedDataService) { }

  ngOnInit() {
    if (StaticViewDataService.Story_listing_View.sortBy) {
      this.sortByValueOf = StaticViewDataService.Story_listing_View.sortBy;
    }
    this.fields = StaticViewDataService.Story_listing_View.fields;
    this.fieldsForTopic = StaticViewDataService.Page_listing_View.fields;

    this.searchQuery.valueChanges
    .pipe(debounceTime(200)
    ,distinctUntilChanged())
    .subscribe(result => {
      this.searchResults(result, 0, data => {
        this.pageNum = 0;
        this.listArray = [];
        this.listIdArray = [];
        if (data['content'].length > 0) {
          this.dataInsertion(data['content']);
          this.noresults = false;
        } else {
          this.noresults = true;
        }
      });

      this.searchResultsforTopic(result, 0, data => {
        this.pageNum = 0;
        this.listArrayTopic = [];
        this.listIdArrayTopic = [];
        if (data['content'].length > 0) {
          this.dataInsertionforTopic(data['content']);
          this.noresults = false;
        } else {
          this.noresults = true;
        }
      });
    });

  }
  getNewTypeDate(dateString){
    return DateUtil.getNewTypeDate(dateString);
  }
 
  getDefaultList(pageNum, callback) {
    let url = this.getDataUrl + '?page=' + pageNum + '&size=' + this.pageSize;
    if (this.sortByValueOf) {
      url += '&sort=' + this.sortByValueOf + ',desc';
    }
    url += this.fields; 
    
    url += '&search=metadata.status:PUBLISHED';
    this.restService.http_get(url)
      .subscribe(data => {
        this.pages = data['totalPages'] > 20 ? 20 : data['totalPages'];
        // this.totalRecords = data['totalElements'];
        callback(data);
      });
  }
  searchResults(query, pageNum, callback) {
    // if (this.config.getEndPoint(this.config.get('views'), this.page_id, this.search_api) !== 'false') {
      if (query) {
        let url = this.getDataUrl + '?page=' + pageNum + '&size=' + this.pageSize;
      if (this.sortByValueOf) {
        url += '&sort=' + this.sortByValueOf + ',desc';
      }
      url += this.fields;
      
      url += '&search=metadata.status:PUBLISHED';
        if (query && query.trim() !== '') {
          url += ',text~' + query;
        }
        url += '&sort=lastModifiedDate,desc';
        this.restService.http_get(url)
          .subscribe(data => {
            this.pages = data['totalPages'] > 20 ? 20 : data['totalPages'];
            callback(data);
          },
          error => {
            console.log(error);
          });
      } else {
        this.getDefaultList(pageNum, data => {
          callback(data);
        });
      }
    // } 
    // else {
    //   console.log('url not found');
    // }
  }

  getDefaultListForTopic(pageNum, callback) {
    let url = this.getTopicData + '?page=' + pageNum + '&size=' + this.pageSize;
    if (this.sortByValueOf) {
      url += '&sort=' + this.sortByValueOf + ',desc';
    }
    url += this.fieldsForTopic; 
    
    url += '&search=pageType:TOPIC,status:PUBLISHED';
    this.restService.http_get(url)
      .subscribe(data => {
        this.pages = data['totalPages'] > 20 ? 20 : data['totalPages'];
        callback(data);
      });
  }
  searchResultsforTopic(query, pageNum, callback) {
      if (query) {
        let url = this.getTopicData + '?page=' + pageNum + '&size=' + this.pageSize;
      if (this.sortByValueOf) {
        url += '&sort=' + this.sortByValueOf + ',desc';
      }
      url += this.fieldsForTopic;
      
      url += '&search=pageType:TOPIC,status:PUBLISHED';
        if (query && query.trim() !== '') {
          url += ',name~' + query;
        }
        this.restService.http_get(url)
          .subscribe(data => {
            this.pages = data['totalPages'] > 20 ? 20 : data['totalPages'];
            callback(data);
          },
          error => {
            console.log(error);
          });
      } else {
        this.getDefaultListForTopic(pageNum, data => {
          callback(data);
        });
      }
  }

  dataInsertion(data) {
    for (let i = 0; i < data.length; i++) {
      if (data[i] !== null) {
        this.listArray.push(data[i]);
        this.listIdArray.push(data[i].id);
      }
    }
  }
  dataInsertionforTopic(data) {
    for (let i = 0; i < data.length; i++) {
      if (data[i] !== null) {
        this.listArrayTopic.push(data[i]);
        this.listIdArrayTopic.push(data[i].id);
      }
    }
  }
  getPageurl(obj){
    this.hyperlinkUrl = this.sharedService.currentDomainUrl + obj.metadata.url;
    // this.sendpageUrlToParentfn.emit(obj.url);
  }
  getPageurlforTopic(obj){
    this.hyperlinkUrl = this.sharedService.currentDomainUrl + obj.url;
  }

  sendStoryToParent() {
    this.sendpageUrlToParentfn.emit(this.hyperlinkUrl);
  }
}
